document.addEventListener('DOMContentLoaded', () => {
  const sizeButtons = document.querySelectorAll('.card-product__size-btn');
  const addClassToButton = (button) => {
    return new Promise((resolve, reject) => {
      // console.time('addClassToButton');
      const cardInner = button.closest('.card');
      const sizeWrapper = cardInner?.querySelector('.component_product_size_wrapper ');

      if (!sizeWrapper) {
        reject(new Error('Size wrapper not found'));
        return;
      }

      sizeWrapper.classList.toggle('active');
      resolve('Class added'); // Message payload 'Class added' is optional
      // console.timeEnd('addClassToButton');
    });
  };

  sizeButtons.forEach(button => {
    button.addEventListener('click', async () => {
      try {
        await addClassToButton(button); // Pause 'click' handler until addClassToButton() returns the Promise(resolved or rejected)
      } catch (e) {
        console.warn(e.message);
      }
    });
  });
});
